"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSpecies_1 = require("../helpers/getSpecies");
var empty_1 = require("./empty");
function combineLatest() {
    if (arguments.length < 1) {
        return empty_1.EMPTY;
    }
    var size = arguments.length;
    var streams = Array.prototype.slice.call(arguments);
    var flags = streams.map(function (_, i) { return Math.pow(2, i); });
    // Here we get a final mask matching every flag for every stream
    // Later we gonna start from zero back again and perform OR operation with every
    // next emit of every stream. Resulting mask will become equal to the flagSum
    // value only when every stream will emit at least once.
    // If you feel uncomfortable with bitwise operators, read this great article:
    // https://blog.rinatussenov.com/juggling-bits-in-javascript-bitmasks-128ad5f31bed
    var flagsSum = flags.reduce(function (p, v) { return p | v; }, 0);
    var C = getSpecies_1.getSpecies(streams[0]);
    return new C(function (observer) {
        var result = new Array(size);
        var subscriptions = [];
        var readyMask = 0;
        var completeMask = 0;
        var next = function (index) { return function (value) {
            result[index] = value;
            if (readyMask !== flagsSum) {
                readyMask = readyMask | flags[index];
            }
            if (readyMask === flagsSum) {
                observer.next(result.slice());
            }
        }; };
        var complete = function (index) { return function () {
            completeMask = completeMask | flags[index];
            if (completeMask === flagsSum) {
                observer.complete();
            }
        }; };
        streams.forEach(function (stream, index) {
            subscriptions.push(stream.subscribe({
                next: next(index),
                complete: complete(index),
                error: function (reason) {
                    observer.error(reason);
                }
            }));
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map